import { render, staticRenderFns } from "./EmptyState.vue?vue&type=template&id=4a787174&scoped=true"
import script from "./EmptyState.vue?vue&type=script&lang=ts"
export * from "./EmptyState.vue?vue&type=script&lang=ts"
import style0 from "./EmptyState.vue?vue&type=style&index=0&id=4a787174&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a787174",
  null
  
)

export default component.exports